import { render, staticRenderFns } from "./IconMenuFilemanager.vue?vue&type=template&id=8646a6e8"
import script from "./IconMenuFilemanager.vue?vue&type=script&lang=js"
export * from "./IconMenuFilemanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports